import type { CachedCredentialDto } from '@terra/shared-contracts-authenticator';
import { applyCredentialMaterialToHeaders } from '@terra/shared-utils';
import {
  setHeader,
  removeHeader,
  parseHeaders,
} from '../../utils/authHeaderDetection';

export function applyCredentialToRequestText({
  requestText,
  credential,
  previousCredential,
}: {
  requestText: string;
  credential: CachedCredentialDto;
  previousCredential?: CachedCredentialDto;
}): string {
  let newValue = requestText;

  if (previousCredential) {
    const newCredentialHeaderKeys = new Set(
      credential.headers.map((header) => header.key.toLowerCase()),
    );
    if (credential.cookies.length > 0) {
      newCredentialHeaderKeys.add('cookie');
    }

    previousCredential.headers.forEach((prevHeader) => {
      if (!newCredentialHeaderKeys.has(prevHeader.key.toLowerCase())) {
        newValue = removeHeader({ text: newValue, headerName: prevHeader.key });
      }
    });
    if (
      previousCredential.cookies.length > 0 &&
      !newCredentialHeaderKeys.has('cookie')
    ) {
      newValue = removeHeader({ text: newValue, headerName: 'Cookie' });
    }
  }

  const existingHeaders = Object.fromEntries(
    parseHeaders(newValue).map((header) => [header.name, header.value]),
  );
  const mergedHeaders = applyCredentialMaterialToHeaders({
    existingHeaders,
    material: {
      headers: credential.headers,
      cookies: credential.cookies,
    },
  });

  let result = newValue;
  for (const [headerName, headerValue] of Object.entries(mergedHeaders)) {
    result = setHeader({
      text: result,
      headerName,
      value: headerValue,
    });
  }

  return result;
}
